module.exports = __webpack_public_path__ + "f66f32e634b31c73c5dc632e4d1b1630.png";